import { getUrlParameter } from '../../utils/utilities';
import { CookieStorage } from 'cookie-storage';
import { validateDoctorCode } from '../../utils/doctorCodes';
let doctorCodeURL;
export const cookieStorage = new CookieStorage({
    path: '/',
});
const init = () => {
    checkDoctorCodeInURL();
};
const checkDoctorCodeInURL = () => {
    doctorCodeURL = getUrlParameter('sdc') || '';
    if (doctorCodeURL !== '' && doctorCodeURL !== null && validateDoctorCode(doctorCodeURL, 'url')) {
        const expires = new Date();
        expires.setTime(expires.getTime() + 1 * 24 * 60 * 60 * 1000);
        cookieStorage.setItem('dcu', doctorCodeURL, {
            path: '/',
            expires,
        });
    }
};
export const getCookieSavedDoctorCode = () => {
    const doctorCodeCookie = cookieStorage.getItem('dcu');
    // We revalidate in case the cookie has already expired
    if (doctorCodeCookie && validateDoctorCode(doctorCodeCookie, 'url')) {
        return doctorCodeCookie;
    }
    return '';
};
export default {
    init,
};
